import { FirefoxButton } from './FirefoxButton'

export { FirefoxButton }



// WEBPACK FOOTER //
// ./client/Components/FirefoxButton/index.js